import prodStore from './store.prod'
import devStore from './store.dev'
import createRootReducer from './createRootReducer'
import { AppState, Store } from './types'

export default process.env.NODE_ENV === 'production' ? prodStore : devStore

// @ts-ignore
export { AppState, Store, createRootReducer }
